// extracted by mini-css-extract-plugin
export default {"cardBody":"viewCard_cardBody__alm4u","cardHeader":"viewCard_cardHeader__TyEZJ","cardContent":"viewCard_cardContent__iS8oz","closedRow":"viewCard_closedRow__nixex"};